import { render, staticRenderFns } from "./editYouzhicaiProduct.vue?vue&type=template&id=634ae498&scoped=true&"
import script from "./editYouzhicaiProduct.vue?vue&type=script&lang=js&"
export * from "./editYouzhicaiProduct.vue?vue&type=script&lang=js&"
import style0 from "./editYouzhicaiProduct.vue?vue&type=style&index=0&id=634ae498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ae498",
  null
  
)

export default component.exports